<ng-container *ngFor="let item of items">

  <div [ngSwitch]="item.itemName">

    <conf-properties-detail *ngSwitchCase="'PropertyPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></conf-properties-detail>

    <tab-detail *ngSwitchCase="'Tab'" [isPrintView]="isPrintView" [confUIItem]="item"></tab-detail>

    <bom-detail *ngSwitchCase="'BomPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></bom-detail>

    <data-selector-detail *ngSwitchCase="'DataSelector'" [confUIItem]="item" [isPrintView]="isPrintView"></data-selector-detail>

    <attributes-detail *ngSwitchCase="'AttributePanel'" [confUIItem]="item" [isPrintView]="isPrintView"></attributes-detail>

    <graphics-detail *ngSwitchCase="'GraphicsPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></graphics-detail>

    <prices-detail *ngSwitchCase="'PriceListPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></prices-detail>

    <documents-detail *ngSwitchCase="'DocumentsPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></documents-detail>

    <code-detail *ngSwitchCase="'CodePanel'" [confUIItem]="item" [isPrintView]="isPrintView"></code-detail>

    <visualization-detail *ngSwitchCase="'VisualizationPanel'" [confUIItem]="item" [isPrintView]="isPrintView"></visualization-detail>

    <image-detail *ngSwitchCase="'ImagePanel'" [confUIItem]="item" [isPrintView]="isPrintView"></image-detail>

    <form-detail *ngSwitchCase="'Form'" [confUIItem]="item" [isPrintView]="isPrintView"></form-detail>

  </div>

</ng-container>